module.exports = __webpack_public_path__ + "static/img/Bottom-tail.981433c3.svg";